import React, { useEffect, useState } from 'react';
import { LoadingOutlined, SmileOutlined, SolutionOutlined, UserOutlined } from '@ant-design/icons';
import { Card, Steps } from 'antd';
import { RequestService } from 'libs/shared-services/vms/src/lib/request.service';
import { RequestById } from 'libs/shared-models/vms/src/lib/request-form/request.request';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { RequestFormDto } from 'libs/shared-models/vms/src/lib/request-form/request.dto';


const { Step }= Steps;


export interface VisitorStatusReportProps {
    id:number;
  };

export function VisitorStatusReport(props:VisitorStatusReportProps) {
 const {id } = props;
 const service = new RequestService();
 const [request,setRequest] = useState<any>('wait');
 const [hodStatus,setHodStatus] = useState<any>('wait');
 const [hrStatus, setHrStatus] = useState<any>('wait');
 const [finish,setFinish] = useState<any>('wait');
 const [requestdesc,setRequestdesc] =useState<any>(' - ');
 const [hodStatusdesc,setHodStatusdesc] = useState<any>('Open');
 const [hrStatusdesc, setHrStatusdesc] = useState<any>('Open');
 const [finishdesc,setFinishdesc] = useState<any>('-');
 const [hodrejres,sethodrejres] = useState<any>('');
 const [hrrejres,sethrrejres] = useState<any>('');


 useEffect(()=>{
  console.log(id);
  console.log('----------------------')
  getDetailes(id);
 },[])

 const getDetailes = (id) => {
  const req = new RequestById(id)
  service.getReqIdPreviewData(req).then(res => {
    if(res.status) {
      setRequest('finish')
      setRequestdesc('Applied')
      console.log(res.data);
      console.log('******************');
      statusCheck(res.data[0]);
    } else {
      AlertMessages.getErrorMessage(res.internalMessage);
    }
  })

  const statusCheck = (req) => {
    console.log(req.statusByHod,"hod")
    console.log(req.statusByHr,"hr")
    if(req.statusByHod == 'APPROVED') {
      setHodStatus('finish')
      setHodStatusdesc('Approved')
    } else if(req.statusByHod == 'REJECTED') {
      setHodStatus('error')
      setHodStatusdesc(`Rejected.${' '}Reason:${req.rejectionReason}`)
    }
    if(req.statusByHr == 'APPROVED') {
      setHrStatus('finish')
      setHrStatusdesc('Approved')
    } else if (req.statusByHr == 'REJECTED') {
      setHrStatus('error')
      setHrStatusdesc(`Rejected.${' '}Reason:${req.rejectionReason}`)
    }
    if(req.statusByHod == 'APPROVED' && req.statusByHr == 'APPROVED') {
      setFinish('finish')
      setFinishdesc('Finished')
    }
  }

 }
 return(
  <div style={{padding:'10%', marginLeft:'20%'}}>
  <Card style={{width: 500, textAlign:'center'}} title={'Visitor Approval Tracking Information'}>
  <Steps direction='vertical'>
    <Step title="Request Sent" status={request} description={requestdesc}></Step>
    <Step title="Hod Status" status={hodStatus} description={hodStatusdesc}></Step>
    <Step title="Hr Status" status={hrStatus} description={hrStatusdesc}></Step>
    <Step title="Finished" status={finish} description={finishdesc}></Step>
    {/* <Step title="Waiting"></Step> */}

  </Steps>
  </Card>
  </div>
 );
}

export default VisitorStatusReport;